


















import Vue from 'vue';
import ReturnToTopButton from '@/components/common/buttons/ReturnToTopButton.vue';
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    name: 'Footer',
    components: { ReturnToTopButton },
    data: function() {
        return {
            isVisible: false,
            isScrollTop: true,
            version: process.env.PORTAL_VERSION,
        };
    },
    computed: {
        ...mapCustomLabelsState(['footerText']),
        ...mapRootState(['portalBranding']),
    },
    mounted() {
        // wait 100ms to have a full page render
        setTimeout(() => {
            this.updateButtonDisplay();
        }, 100);
    },
    created() {
        window.addEventListener('scroll', this.updateButtonDisplay);
    },
    destroyed() {
        window.removeEventListener('scroll', this.updateButtonDisplay);
    },
    methods: {
        isElementInView(el: Element) {
            const { top, bottom } = el.getBoundingClientRect();
            return top < window.innerHeight && bottom >= 0;
        },
        updateIsVisible() {
            this.isVisible = this.isElementInView(this.$el);
        },
        updateIsScrollTop() {
            this.isScrollTop = (window.scrollY ?? window.pageYOffset) === 0; // pageYOffset is only for IE 11
        },
        updateButtonDisplay() {
            this.updateIsVisible();
            this.updateIsScrollTop();
        },
    },
});
